module.exports = __webpack_public_path__ + "static/media/54_1129.9a05d71e.webp";